import { UtilityService } from './index'
import Compressor from 'compressorjs';

class FileUploadService {

    async uploadFileForFabric(file,moduleName) {
        return await new Promise((resolve, reject) => new Compressor(file, {
            quality: 0.6,
            async success(data) {
                const formData = new FormData();
                formData.append('file', data, data.name);
                formData.append('fileType', moduleName)
                let result = await fetch(UtilityService.baseUrl() + `api/uploadFile/${moduleName}`, {
                    method: "POST",
                    headers: {
                        'AuthToken': localStorage.getItem("authToken")
                    },
                    body: formData
                });
                resolve({
                    status: result.status,
                    text: await result.json()
                })
            },
            error(err) {
                reject(err )
            },
        }))
    }
    

    async uploadFile(file, moduleName) {
        var formData = new FormData()
        formData.append('file', file)
        formData.append('fileType', moduleName)

        let result = await fetch(UtilityService.baseUrl() + `api/uploadFile/${moduleName}`, {
            method: "POST",
            headers: {
                // 'Accept': 'application/json',
                // 'Content-Type': 'multipart/form-data',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async uploadMeetingNoteImage(files) {
        var formData = new FormData()
        for (let i = 0; i < files.length; i++) {
            formData.append("file", files[i])
        }

        let result = await fetch(UtilityService.baseUrl() + `api/uploadFile/multiple/MeetingNote`, {
            method: "POST",
            headers: {
                // 'Accept': 'application/json',
                // 'Content-Type': 'multipart/form-data',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : formData
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

}
export default new FileUploadService();


// WEBPACK FOOTER //
// ./src/services/fileupload.service.js